import { UnitsPage } from '@apps-common/apps/portal/pages/units/Index'

export const Units = () => <UnitsPage />
